module.exports = __webpack_public_path__ + "img/DE00412.8d480e67.png";